/*
 * Sticky-Leiste mobil (Design BF26) - "Merken". Gegenstueck zu snippets/ll-sticky-bar.liquid.
 *
 * Die Merkliste gehoert der App Wishlist King / Swish, die sich an den Merken-Button der Produktseite bindet
 * (.ll-wishlist-button neben Filialabholung, snippets/buy-buttons.liquid). Statt die App-Schnittstelle nachzubauen,
 * leitet der Sticky-Button den Klick an genau diesen Button weiter - die App macht dann exakt dasselbe wie dort.
 * Den Zustand (gemerkt = Klasse wk-selected am Original) spiegelt ein MutationObserver auf den Sticky-Button.
 */
const findSource = () => document.querySelector(".ll-wishlist-button");

const sync = (target, source) => {
  const active = Boolean(source?.classList.contains("wk-selected"));
  target.classList.toggle("is-active", active);
  target.setAttribute("aria-pressed", String(active));
};

document.querySelectorAll("[data-ll-sticky-wishlist]").forEach((target) => {
  const source = findSource();
  if (!source) {
    target.hidden = true;
    return;
  }

  sync(target, source);
  new MutationObserver(() => sync(target, source)).observe(source, { attributes: true, attributeFilter: ["class"] });

  target.addEventListener("click", () => {
    findSource()?.click();
  });
});
